module.exports = __webpack_public_path__ + "img/logo.efc0f4ba.png";